import React, { useEffect, useRef, useState } from 'react';

import Sort from './components/Sort.jsx';
import Modal from './components/Modal';
import Search from './components/Search.jsx';
import FilterBox from "./components/FilterBox.jsx";
import CourseCards from "./components/CourseCards.jsx";

import "./App.scss";

function App(props) {

  function FilterHandler(e) {
    // console.log('Filter, e: ', e);
    setFilters(e);
  }
  function SortHandler(e) {
    // console.log('Sort, e: ', e);
    setSortby(e);
  }
  function SearchHandler(e) {
    // console.log('Search, e: ', e);
    setTerm(e);
  }

  // console.log('props, app', props);
  const [term, setTerm] = useState();
  const [filters, setFilters] = useState();
  const [sortby, setSortby] = useState();
  // console.log('App: filters: ', filters)
  // console.log('App: sortby: ', sortby)
  // console.log('App: term: ', term)

  const appRef = useRef(null)

  useEffect(() => {
    if (appRef.current) {
      window.catalogComponent = appRef.current
    }
  }, [appRef])

  return (
    <div ref={appRef} className="catalog-page">
      <div className="row">
        <div className="col-md-7">
          <h1 className="mt-0">Catalog</h1>
          <p className="mt-4 mr-4 d-none">Browse our extensive list of online Programs and Courses taught by world-class expert faculty. Enroll today.</p>
        </div>
        <div className="col-md-5">
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-md-12">
          <div className="d-inline-flex" action="">
            <Search title="Term" onChange={SearchHandler}></Search>
            <Sort title="Sort" onChange={SortHandler}></Sort>
            <FilterBox title="Filter" onChange={FilterHandler}></FilterBox>
          </div>
        </div>
      </div>
      <hr />
      <CourseCards props={props} {...{term, filters, sortby}}  searchTerm={term}></CourseCards>
      <Modal></Modal>
    </div>
  );
}

export default App;
